export default __webpack_public_path__ + "static/media/logoErr.0eedb68c.png";